export const formatPercentage = (ratio: number) => {
  const percentage = ratio * 100;
  const rounded = Math.round(percentage);

  if (rounded === 0 && percentage > 0) return '<1%';
  if (rounded === 100 && percentage < 100) return '>99%';

  return `${rounded}%`;
};
